import React, { useEffect, useState } from 'react';
import '../css/InviteOrgModal.css';

export function useInviteOrgModal() {
  const [pending, setPending] = useState(null);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [busy, setBusy] = useState(false);

  const ask = (item) => {
    setError('');
    setSuccess('');
    setBusy(false);
    setEmail(item?.email || '');
    setPending(item);
  };

  const clear = () => {
    setPending(null);
    setEmail('');
    setError('');
    setSuccess('');
    setBusy(false);
  };

  return { pending, email, setEmail, error, setError, success, setSuccess, busy, setBusy, ask, clear };
}

export default function InviteOrgModal({ name, email, onEmailChange, onSubmit, onCancel, error, success, busy }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !busy) onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [busy, onCancel]);

  const label = (name || '').trim() || 'this organisation';

  return (
    <div
      className="invite-org-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="invite-org-modal-title"
      aria-describedby="invite-org-modal-desc"
      onClick={() => { if (!busy) onCancel(); }}
    >
      <div className="invite-org-modal-panel" onClick={(e) => e.stopPropagation()}>
        <h2 id="invite-org-modal-title" className="invite-org-modal-title">
          Invite to Portal
        </h2>
        <p id="invite-org-modal-desc" className="invite-org-modal-body">
          Send a set-password link to <span className="invite-org-modal-name">{label}</span>. Safe to
          re-send if they haven&apos;t set a password yet.
        </p>

        {success ? (
          <div className="invite-org-modal-success" role="status">
            {success}
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          >
            <input
              type="email"
              className="invite-org-modal-input"
              placeholder="contact@example.com"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              disabled={busy}
              autoFocus
              required
            />
            {error ? (
              <div className="invite-org-modal-error" role="alert">
                {error}
              </div>
            ) : null}
            <div className="invite-org-modal-actions">
              <button
                type="submit"
                className="invite-org-modal-btn invite-org-modal-btn--confirm"
                disabled={busy || !email.trim()}
              >
                {busy ? 'Sending...' : 'Send Invite'}
              </button>
              <button
                type="button"
                className="invite-org-modal-btn invite-org-modal-btn--cancel"
                onClick={onCancel}
                disabled={busy}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
